import { render, staticRenderFns } from "./orders-list.vue?vue&type=template&id=16d1c2e2&"
import script from "./orders-list.vue?vue&type=script&lang=ts&"
export * from "./orders-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports